import { Routes } from '@angular/router';
import { authGuard } from './shared/guards/auth.guard';
import { accessGuard } from './shared/guards/access.guard';

export const routes: Routes = [
    {
        path: '',
        pathMatch: 'full',
        redirectTo: 'auth/login'
    },
    {
        path: 'auth',
        canActivate: [authGuard],
        loadComponent: () => import('./auth/auth.component'),
        title: 'Detailyx',
        children: [
            {
                path: '',
                redirectTo: 'login',
                pathMatch: 'full'
            },
            {
                path: 'login',
                loadComponent: () => import('./auth/login/login.component'),
                title: 'Detailyx - Login'
            },
            {
                path: 'recover',
                loadComponent: () => import('./auth/recover/recover.component'),
                title: 'Detailyx - Recover Password'
            }
        ]
    },
    {
        path: 'auth/sent-recover',
        loadComponent: () => import('./auth/sent-recover/sent-recover.component'),
        title: 'Detailyx - Recovery Email Sent'
    },
    {
        path: 'dashboard',
        canActivate: [authGuard],
        canActivateChild: [accessGuard],
        loadComponent: () => import('./dashboard/dashboard.component'),
        data: { breadcrumb: 'Home' },
        children: [
            {
                path: '',
                redirectTo: 'inicio',
                pathMatch: 'full'
            },
            {
                path: 'configuraciones',
                loadComponent: () => import('./dashboard/settings/settings.component'),
                title: 'Settings',
                data: { breadcrumb: 'Settings' },
                children: [
                    {
                        path: '',
                        redirectTo: 'users',
                        pathMatch: 'full'
                    },
                    {
                        path: 'menu',
                        loadComponent: () => import('./dashboard/settings/menu/menu.component'),
                        title: 'Menu',
                        data: { breadcrumb: 'Menu' }
                    },
                    {
                        path: 'roles',
                        data: { breadcrumb: 'Roles' },
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('./dashboard/settings/roles/roles.component'),
                                title: 'Roles',
                                data: { breadcrumb: null }
                            },
                            {
                                path: 'nuevo',
                                loadComponent: () => import('./dashboard/settings/roles/roles-editor/roles-editor.component'),
                                title: 'New Role',
                                data: { breadcrumb: 'New' }
                            },
                            {
                                path: ':id',
                                loadComponent: () => import('./dashboard/settings/roles/roles-editor/roles-editor.component'),
                                title: 'Edit Role',
                                data: { breadcrumb: 'Edit' }
                            }
                        ]
                    },
                    {
                        path: 'usuarios',
                        loadComponent: () => import('./dashboard/settings/users/users.component'),
                        title: 'Users',
                        data: { breadcrumb: 'Users' },
                        children: [
                            {
                                path: '',
                                loadComponent: () => import('./dashboard/settings/users/users-home/users-home.component'),
                                title: 'Users',
                                data: { breadcrumb: null },
                            },
                            {
                                path: 'detalle',
                                loadComponent: () => import('./dashboard/settings/users/user-detail/user-detail.component'),
                                title: 'New User',
                                data: { breadcrumb: 'New' }
                            },
                            {
                                path: 'detalle/:id',
                                loadComponent: () => import('./dashboard/settings/users/user-detail/user-detail.component'),
                                title: 'Detail',
                                data: { breadcrumb: 'Detail' }
                            },
                            {
                                path: 'roles',
                                loadComponent: () => import('./dashboard/settings/roles/roles.component'),
                                title: 'Roles',
                                data: { breadcrumb: 'Roles' },
                            },
                        ]
                    },
                ]
            },
            {
                path: 'cms',
                loadComponent: () => import('./dashboard/cms/cms.component'),
                title: 'CMS',
                children: [
                    {
                        path: 'vehicle-catalog',
                        loadComponent: () => import('./dashboard/cms/vehicle-catalog/vehicle-catalog.component'),
                        title: 'Clasificación de vehículos',
                        data: { breadcrumb: 'Clasificación de vehículos' },
                    },
                ],
            },
            {
                path: 'business',
                loadComponent: () => import('./dashboard/business/business.component'),
                title: 'Business',
                data: { breadcrumb: 'Business' },
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./dashboard/business/business-home/business-home.component'),
                        title: 'Business',
                        data: { breadcrumb: null },
                    },
                    {
                        path: 'detail/:id',
                        loadComponent: () => import('./dashboard/business/business-detail/business-detail.component'),
                        title: 'Detail',
                        data: { breadcrumb: 'Detail' }
                    },
                ]
            },
            {
                path: 'payments-billing',
                loadComponent: () => import('./dashboard/payments-billing/payments-billing.component'),
                title: 'Payments and Billing',
                data: { breadcrumb: 'Payments and Billing' },
                children: [
                    {
                        path: '',
                        redirectTo: 'summary',
                        pathMatch: 'full'
                    },
                    {
                        path: 'summary',
                        loadComponent: () => import('./dashboard/payments-billing/billing-summary/billing-summary.component'),
                        data: { breadcrumb: 'Summary' },
                    },
                    {
                        path: 'fees',
                        loadComponent: () => import('./dashboard/payments-billing/billing-fees/billing-fees.component'),
                        data: { breadcrumb: 'Fees' }
                    },
                    {
                        path: 'transactions',
                        loadComponent: () => import('./dashboard/payments-billing/billing-transactions/billing-transactions.component'),
                        data: { breadcrumb: 'Transactions' }
                    },
                ]
            },
            {
                path: 'support',
                loadComponent: () => import('./dashboard/support/support.component'),
                title: 'Support',
                data: { breadcrumb: 'Support' },
            },
            {
                path: 'inicio',
                loadComponent: () => import('./dashboard/home/home.component'),
                title: 'Detailyx - Home',
            },
            {
                path: 'onboarding',
                loadComponent: () => import('./dashboard/onboarding/onboarding.component'),
                data: { breadcrumb: 'Onboarding' },
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./dashboard/onboarding/onboarding-home/onboarding-home.component'),
                        title: 'Onboarding',
                        data: { breadcrumb: null },
                    },
                    {
                        path: 'detail/:id',
                        loadComponent: () => import('./dashboard/onboarding/onboarding-detalle/onboarding-detalle.component'),
                        title: 'Detail',
                        data: { breadcrumb: 'Detail' }
                    },
                ]
            },
            {
                path: 'bookings',
                loadComponent: () => import('./dashboard/bookings/bookings.component'),
                title: 'Bookings',
                data: { breadcrumb: 'Bookings' },
                children: [
                    {
                        path: '',
                        loadComponent: () => import('./dashboard/bookings/bookings-home/bookings-home.component'),
                        title: 'Bookings',
                        data: { breadcrumb: null },
                    },
                    {
                        path: 'detail/:id',
                        loadComponent: () => import('./dashboard/bookings/booking-detail/booking-detail.component'),
                        title: 'Detail',
                        data: { breadcrumb: 'Detail' }
                    },
                ]
            },
            {
                path: 'reviews',
                loadComponent: () => import('./dashboard/reviews/reviews.component'),
                title: 'Reviews',
                data: { breadcrumb: 'Reviews' },
            },
        ]
    },
    {
        path: '**',
        pathMatch: 'full',
        redirectTo: 'auth/login',
    }
];
